import Image from 'next/image'
import Link from 'next/link'

import { getArticleUrl } from '@/lib/api-connector-strapi-cms/utils/getArticleUrl.utils'
import { ImageType } from '@/lib/models/components/image.types'

export type CardArticleProps = {
  category?: string
  title: string
  description: string
  authorName: string
  datePublication: string
  linkArticle: string
  image: ImageType
}

export const CardArticle = ({
  category,
  title,
  description,
  authorName,
  datePublication,
  linkArticle,
  image,
}: CardArticleProps) => {
  return (
    <Link
      target={category == 'external' ? '_blank' : '_self'}
      href={category == 'external' ? linkArticle : getArticleUrl(linkArticle)}
      className="card-article-promoted group flex min-h-[16rem] cursor-pointer border-b border-gray-400 px-6 pt-8 xl:justify-between xl:px-0 xl:py-8 xl:pl-10"
    >
      <div className="grid grid-cols-1 pb-8 xl:grid-cols-3 xl:gap-24 xl:pb-0">
        <div className="flex items-center">
          <Image
            className="w-full pb-4 xl:max-h-[240px] xl:pb-0"
            src={image.url}
            width={image.width}
            height={image.height}
            alt="Card image"
          />
        </div>
        <div className="col-span-2 flex h-full flex-1 flex-col justify-between">
          <div className="col-span-2">
            <div className="card-article-promoted-title paragraph-xxl mb-2 font-semibold">
              {title}
            </div>
            <div className="paragraph-s pb-6 text-gray-800 xl:pb-8">{`${
              authorName != 'author' ? authorName + ' •' : ''
            }    ${datePublication}`}</div>
          </div>
          <div className="card-article-promoted-text paragraph-s">
            {description}
          </div>
        </div>
      </div>
    </Link>
  )
}
